import BaseControl from './../BaseControl';
import FSForms from './../../Form/js/fsForms';
import Immutable from 'Immutable';

var submitBtnId;
var uploadStarted;

/**
 * @author Pavel Homolka
 */
export default class SingleEditDocumentControl extends BaseControl
{
  /** @type String */
  formId;

  /** @type String */
  submitBtnId;

  /** @type String */
  changeURL;

  /** @type String */
  jsClass;

  /** @type String */
  userLanguage;

  /** @type String */
  changeItem = null;

  /** @type String */
  initialCaption;

  /** @type String */
  submitBtnLabel;

  /** @type Immutable::Map*/
  stateList;

  /** @type bool */
  isAjax = false;

  /** @type jQuery */
  form;

  /** @type Object */
  reducer;
  
  /** @type String */
  focused;

  /** Construct and init **********************************************************************************************/

  constructor(formId, changeURL, jsClass, stateList, userLanguage, submitBtnId, initialCaption, submitBtnLabel)
  {
    super();
    this.formId = formId;
    this.changeURL = changeURL;
    this.jsClass = jsClass;
    this.stateList = stateList;
    this.userLanguage = userLanguage;
    this.submitBtnId = submitBtnId;
    this.initialCaption = initialCaption;
    this.submitBtnLabel = submitBtnLabel;
  }

  /**
   * @return void
   */
  init()
  {
    // handlers for form
    this.form = $(`#${this.formId}`);
    this.form.change(this.onChange.bind(this));
    this.form.submit(this.onSubmit.bind(this));

    readOnlySelectSearch();
    readOnlyDateTime();
    
    $(document).on("blur", ".fs-dateTime-picker",this.onChange.bind(this));
    $(document).on("blur", ".fs-date-picker",this.onChange.bind(this));
    $(document).on("blur", ".fs-time-picker",this.onChange.bind(this));
    
    // call method for detect relations count
    if (typeof refreshInfoRelationsCount == 'function') { 
      refreshInfoRelationsCount(); 
    }        

    // handle for submit button
    $(`#${this.submitBtnId}`).click(this.onSubmitBtnClick.bind(this));

    // init bootstrap file input
    //var fileInput = this.form.find('input[name="editForm_newVersion"]');
    //fileInput.fileinput({ language: this.userLanguage, initialCaption: this.initialCaption });
    //fileInput.on('fileloaded', this.fileLoaded.bind(this));
    //fileInput.on('fileclear', this.fileClear.bind(this));
    
    var fileInput = this.form.find('input[name="editForm_newVersion"]');
    fileInput.on('change', this.fileLoaded.bind(this));
    
    var dropzone_file_remover = this.form.find('.dropzone_file_remover').first();
    //dropzone_file_remover.on('click', this.fileClear.bind(this));
    
    
    var fileInputNote = $('.note_upload_button');
    fileInputNote.fileinput({ language: this.userLanguage});

    // init bootstrap templates input
    var templateSelect = $('.editForm-TemplatesModal-select');
    var templateInput = this.form.find('[id*=editDocument_newTemplate]');
    templateSelect.on('click', this.templateChange.bind(this, templateInput));

    // create JS reducer
    if(window[this.jsClass] != undefined)
    {
      this.reducer = Object.assign({}, window[this.jsClass]);

      // call Reducer::init
      if(typeof this.reducer.init === 'function')
      {
        this.reducer.init(this, this.stateList);
      }
    }
  }

  /** Handles *********************************************************************************************************/

  /**
   * @param jQuery.Event event
   */
  onChange(event)
  {
    var currentStateForEl = this.getCurrentStateForEl($(event.target));

    // skip onChange for <input type="file">
     if(currentStateForEl.name == 'editForm_newVersion')
     {
     return;
     }

    // update state
    var newState = Immutable.Map({
      nameMeta: currentStateForEl.name,
      value: currentStateForEl.value,
      isRequired: currentStateForEl.isRequired,
      isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
      metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
    });
    var newStateList = this.stateList.set(currentStateForEl.name, newState);
    this.stateList = newStateList.set('changedItem', currentStateForEl.name);

    // call user reducer and refresh form
    if(this.reducer !== undefined && typeof this.reducer.onChange === 'function')
    {
      var newStateList = this.reducer.onChange(this.stateList);
      if(!this.stateList.equals(newStateList))
      {
        this.stateList = newStateList;
        this.refresh();
      }
    }

    // call server side callback
    if(this.canCallServer())
    {
      this.sendState();
    }
  }
  
  canSubmitFormTest()
  {
    return true;
  }

  /**
   * @param jQuery.Event event
   */
  
  onSubmitBtnClick(event)
  {
    if(this.canSubmitFormTest() === true)
    {
      this.form.trigger('submit');
    }
    else
    {
      event.preventDefault();
    }  
  }

  /**
   * @param jQuery.Event event
   */
  onSubmit(event)
  {
    if(!Nette.validateForm(document.getElementById(this.formId)))
    {
      return false;
    }

    if(window.FormData !== undefined) // FormData may not exist for IE.
    {
      var formData = new FormData(document.getElementById(this.formId));
      var is_safari = isSafari();
      if(is_safari == true)
      {  
        disableEmptyFileInputs(this.form,formData);
      } 
      
      this.requestSingle = $.ajax({
        type: 'POST',
        url: this.form.attr('action'),
        canSubmitForm: this.canSubmit,
        data: formData,
        processData: false,  // tell jQuery not to process the data
        contentType: false,   // tell jQuery not to set contentType
        beforeSend: this.onBeforeSend.bind(this),
        success: this.onSuccess.bind(this),
        error: this.onError.bind(this),
        complete: this.onComplete.bind(this),
        xhr: function(xhr){
            var xhr = $.ajaxSettings.xhr();
            xhr.upload.onprogress = function(evt){

                if ((Date.now() - uploadStarted) > 1000){

                    var footer = $('#'+submitBtnId).parent();

                    footer.children('.progress-cover').show();

                    if (evt.lengthComputable) {
                        var value = parseInt( (evt.loaded / evt.total * 100), 10);

                        if (value == 100){
                            footer.find('.progress-text').hide();
                            footer.find('.progress-info').hide();
                            footer.find('.progress-text-success').show();
                            footer.find('.progress-bar').css('width', value+'%');
                        }else{
                            footer.find('.progress-bar').css('width', value+'%');
                            footer.find('.progress-bar').css('width', value+'%');
                            footer.find('.progress-info').text(value+'%');
                        }
                    }
                }
            };
            return xhr;
        }
      });

      event.preventDefault();
    }
    else
    {
      this.showSpin();
    }
  }

  /** Send state ******************************************************************************************************/

  /**
   * @return void
   */
  sendState()
  {
    if(!this.isAjax)
    {
      $.ajax({
        method: 'POST',
        url: this.changeURL,
        contentType: 'application/json',
        data: JSON.stringify({stateList: this.stateList.toJS()}),
        beforeSend: this.onBeforeSend.bind(this),
        success: this.onSuccess.bind(this),
        error: this.onError.bind(this),
        complete: this.onComplete.bind(this)
      });
    }
  }

  /**
   * @param jqXHR
   * @param setting
   */
  onBeforeSend()
  {
    this.isAjax = true;
    this.showSpin();
    uploadStarted = Date.now();
    submitBtnId = this.submitBtnId;

    var footer = $(`#${this.submitBtnId}`).parent();
    footer.find('.progress-text').show();
    footer.find('.progress-info').show();
    footer.find('.progress-text-success').hide();
  }

  /**
   * @param payload
   * @param textStatus
   * @param jqXHR
   */
  onSuccess(payload)
  {
    this.hideSpin();
    waiter_close();

    if(document.activeElement !== null)
    {  
      this.focused = document.activeElement.id;
    }
    else
    {  
      this.focused = '';
    }
      
    if(payload.snippets)
    {
      for (var id in payload.snippets)
      {
        $(`#${id}`).html(payload.snippets[id]);
      }
      FSForms.init();
    }

    if (payload.redirect)
    {
      $('.modal').modal('hide');
      waiter_open('large');
      window.location.href = payload.redirect;
      return false;
    }

    switch (payload.stateList)
    {
      case 'NO_CHANGES':
        break;
      case 'ERROR':
        this.showMessage(payload.msg, 'danger');
        break;
      case 'MESSAGE':
        this.showMessage(payload.msg, 'info');
        break;
      case 'GUI_FORM_SUBMIT_SUCCESS':
        $(".document_edit_form_button_close").trigger('click');
        FSGridSnippet.refreshMainGrid();
        flashMessageSuccess(payload.msg);
        break;
      case 'DASHBOARD_REFRESH':
        $(".document_edit_form_button_close").trigger('click');
        $('#'+payload.key).trigger('click');
        $("#flashMessages").empty();
        flashMessageSuccess(payload.msg);
        break;
      default:
        this.stateList = Immutable.fromJS(payload.stateList);
    }

    //this.hideSpin();
  }

  /**
   * @param jqXHR
   * @param textStatus
   * @param error
   */
  onError()
  {
    this.hideSpin();
    this.showMessage('HTTP error', 'danger');
  }

  /**
   * @return void
   */
  onComplete()
  {
    $(`#${this.submitBtnId}`).parent().children('.progress-cover').hide();
    
    try
    {
      var index_of_grid = this.focused.indexOf("grid");
    }
    catch(err) 
    {
      var index_of_grid = -1;
    }

    if(index_of_grid >= 0 || this.focused == '')
    {  
      $(`#${this.getIdByName(this.stateList.get('changedItem'))}`).focus();
    }
    else
    {
      $('#'+this.focused).focus();
    } 
    
    this.isAjax = false;
    
    readOnlySelectSearch();
    readOnlyDateTime();
    
    if($("#iframe_wrapper").is(':visible') == true )
    {
      runResizable();
      $(".document_edit_row").addClass("changer_row_xs");
      $(".document_edit_row_first").addClass("changer_row_main_xs");
    }  
      
  }

  /** File input *********************************************************************************************************/

  /**
   * @param event
   * @param file
   */
  fileLoaded(event, file)
  {
    var file = this.form.find('input[name="editForm_newVersion"]')[0].files[0];
    
    if(typeof file == "undefined")
    {
      var fileName = '';
    }
    else
    {
      var fileName = file.name;
    }  
    
    var nameDocu = this.form.find('input[name="NAME_DOCU"]');
    if(nameDocu.length == 1)
    {
      //nameDocu.val(fileName);
    }
    $(`#${this.submitBtnId}`).text(this.initialCaption);
  };

  /**
   * @return void
   */
  fileClear()
  {
    var nameDocu = this.form.find('input[name="NAME_DOCU"]');
    if(nameDocu.length == 1)
    {
      nameDocu.val('');
    }
    $(`#${this.submitBtnId}`).text(this.submitBtnLabel);
  };


  /**
   * @param event
   * @param file
   */
  templateChange(event, file, tem)
  {

    var needRefresh = false;
    var templateChoose = this.form.find('[id*=editDocument_newTemplate_chosen] .chosen-single');
    var inputFileName = this.form.find(".editForm-EditFile .file-caption-name");
    var inputFile = this.form.find('.editForm-EditFile .file-input');

    if( templateChoose.text() != '---' )
    {
      //inputFileName.html( templateChoose.html() );
      inputFile.removeClass('file-input-new');


      // fill NAME_DOCU
      if(this.stateList.has('NAME_DOCU'))
      {
        this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], templateChoose.text());
        needRefresh = true;
      }

      /*
       // refresh
       if(needRefresh)
       {
       this.refresh();
       }*/
    }
  }

  /** Helpers *********************************************************************************************************/
  /**
   * Update the form to the current status.
   * @return void
   */
  refresh()
  {
    this.form.find(':input').each((index) =>
    {
      var input = $(this.form[0][index]);
      var label = $(`label[for='${$(input).attr('id')}']`);
      var name = input.attr('name');

      if(this.stateList.has(name))
      {
        var isRequired = this.stateList.getIn([name, 'isRequired']);
        var isReadOnly = this.stateList.getIn([name, 'isReadOnly']);
        var value = this.stateList.getIn([name, 'value']);
        
        if(isReadOnly == true)
        {  
          input.addClass('not-active', true);
        }
        else
        {
          input.removeClass('not-active', true);
        }  

        input.attr('readonly', isReadOnly);
        input.prop('readonly', isReadOnly);

        input.val(value);
        if(isRequired)
        {
          label.addClass('isRequired');
        }
        else
        {
          label.removeClass('isRequired');
        }
      }
    });
    readOnlySelectSearch();
    readOnlyDateTime();
  }

  /**
   * @param String msg
   * @param String type
   */
  showMessage(msg, type)
  {
    var alert = `<div class="alert alert-${type} alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>${msg}</div>`;
    if($(`#${this.formId} .alert`).length > 0)
    {
      $(`#${this.formId} .alert`).remove();
    }
    $(`#${this.formId}`).prepend(alert);
  }

  /**
   * @returns {boolean}
   */
  canCallServer()
  {
    if(this.reducer !== undefined && typeof this.reducer.canCallPHP === 'function')
    {
      return this.reducer.canCallPHP(this.stateList);
    }

    var change_input_array = ['ID_STAT_DOCU', 'ID_CLAS_DOCU', 'ID_RANK_DOCU','FILE_MARK_DOCU','ID_CERT_DOCU','ID_SKART_REZIM_DOCU','DM_CONTRACT_DOCU','ID_LTD_CONF_DOCU','LTD_ACCEPT_DOCU'];

    $('.edit-document-zav').each(function( index )
    {
      change_input_array.push($(this).val());
    });

    if(change_input_array.indexOf(this.stateList.get('changedItem')) != -1)
    {
      return true;
    }

    return false;
  }

  /**
   * @param String name
   * @return String
   */
  getIdByName(name)
  {
    return this.form.find(`:input[name="${name}"]`).attr('id');
  }

  /**
   * @return void
   */
  showSpin()
  {
    //$(`#${this.formId}`).parent().spin();

    waiter_open('large','#editFormParent');
    $(`#${this.formId}`).css('opacity', '0.5');
  }

  /**
   * @return void
   */
  hideSpin()
  {
    //$(`#${this.formId}`).parent().spin(false);
    waiter_close();
    $(`#${this.formId}`).css('opacity', '1');
  }
};




// WEBPACK FOOTER //
// ./client-side/MetadataLogic/SingleEditDocument/SingleEditDocumentControl.js